export const fetchParticipant = ({ participantId }) => ({
    method: 'GET',
    url: `/agenda/${participantId}`
});

export const fetchParticipants = ({ page, search, limit = '10' }) => ({
    method: 'GET',
    url: `/agenda?page=${page}&search=${search}&limit=${limit}`,
})

export const updateParticipant = (participantId, data) => ({
    method: 'PUT',
    url: `/agenda/${participantId}`,
    data
})

export const createParticipant = (data) => ({
    method: 'POST',
    url: '/agenda',
    data
})

export const deleteParticipant = (participantId) => ({
    method: 'DELETE',
    url: `/agenda/${participantId}`,
})

export const addAttachmentParticipant = (participantId, data) => ({
    method: 'POST',
    url: `/agenda/${participantId}/attachment`,
    data
})

export const deleteAttachmentParticipant = (participantId, attachmentId) => ({
    method: 'DELETE',
    url: `/agenda/${participantId}/attachment/${attachmentId}`
})
export const fetchMembers = ({
    search = ''
}) => ({
    method: 'GET',
    url: `/agenda?search=${search}`
});

export const addMember = (values) => ({
    method: 'POST',
    url: '/agenda',
    data: values,
});
